import type { HTMLAttributes, ReactNode } from 'react'

import { CloseButtonProps } from '@chakra-ui/react'
import { DialogTitleProps } from '@radix-ui/react-dialog'

import { DialogHeader, DialogTitle } from '@/shared/ui/Dialog'

interface ModalHeaderProps extends HTMLAttributes<HTMLDivElement> {
	text: string
	headingProps?: DialogTitleProps
	/**
	 * @deprecated this prop is not supported by shadcn/ui
	 */
	closeButtonProps?: CloseButtonProps | Record<string, string>
	leftButton?: ReactNode
}

/**
 * @deprecated use `DialogHeader` from `@/shared/ui/Dialog` instead
 */
export const ModalHeader = ({
	text,
	headingProps,
	leftButton,
	closeButtonProps: _,
	...props
}: ModalHeaderProps) => {
	return (
		<DialogHeader {...props}>
			{leftButton}
			<DialogTitle {...headingProps}>{text}</DialogTitle>
		</DialogHeader>
	)
}
